module.exports = __webpack_public_path__ + "img/bg07.4d6f4cb1.gif";